import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift, faMapMarkerAlt, faCity, faStar, faGlobe, faBook, faBookOpen, faDownload, faGifts, faHandsHelping, faPhone, faRainbow, faShoppingCart, faStore, faVideo, faQrcode } from '@fortawesome/free-solid-svg-icons';
import './MealMarch.css';
import mealmarchimage from '../../assets/pageimages/MealMarch.webp';

function MealMarchHome() {

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>DonaQR - Generosity & Kindness </h2>
      </div>
      <div className="main-content">
      <div className="top-section top-section mt-4 ml-2 mr-0 border border-b-gray-300">
        <div className="button-links flex align-middle justify-center bg-gray-500">
            <div className="bottom-buttons-box"><Link to="/donaqr-myqrlist" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="donaqr-bottomlink-style" />My Codes</Link></div>
            <div className="bottom-buttons-box"><Link to="/scan" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="donaqr-bottomlink-style" />Donate</Link></div>
            <div className="bottom-buttons-box"><Link to="/donaqr-mydonationslist" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="donaqr-bottomlink-style" />My Donations</Link></div>
            <div className="bottom-buttons-box"><Link to="/donaqr-myincentivelist" className="top-button-link"><FontAwesomeIcon icon={faStar} className="donaqr-bottomlink-style" />My Incentives</Link></div>
          </div>
        </div>
        <div className="image-container">
        <div className="relative inset-0 flex border border-b-gray-300">
            <img id="mealmarch-id" src={mealmarchimage} alt="MealMarch Image" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default MealMarchHome;
